import React from 'react';
import PropTypes from 'prop-types';

import MetaList from '../MetaList/MetaList';
import MetaListItem from '../MetaList/MetaListItem';
import EmailForm, { Heading } from '../Forms/ContactInfoForm';
import CustomerInfoSection from './CustomerInfoSection';
import InfoBox from '../../../../UI/InfoBox';


export default class ContactInfo extends React.Component {
    static propTypes = {
        modifierClass: PropTypes.array,
        name: PropTypes.string,
        personalIdentityNumber: PropTypes.string,
        phonenumber: PropTypes.string,
        adressLine1: PropTypes.string,
        adressLine2: PropTypes.string,
        email: PropTypes.string,
        customerSupportUrl: PropTypes.string,
        editing: PropTypes.bool,
        onChangeInfoClick: PropTypes.func,
        onInfoSave: PropTypes.func,
        onInfoCancel: PropTypes.func
    }

    static defaultProps = {
        modifierClass: [],
        title: '',
        children: [],
        excerpt: '',
        customerSupportUrl: '#',
        modifierClass: [],
        editing: false,
        onInfoSave: () => {},
        onInfoCancel: () => {},
        onChangeInfoClick: () => {}
    };

    getContactInfo() {
        if (this.props.editing === false) {
            return (
                <div>
                    {
                        this.props.mobileNumber && <React.Fragment>
                            <Heading>Mobiltelefon</Heading>
                            {this.props.mobileNumber}
                        </React.Fragment>
                    }
                    <Heading>E-postadress</Heading>
                    {this.props.email}
                    <br />
                    <br />
                    <button className="my-pages-btn button button--green" onClick={this.props.onChangeInfoClick}>Ändra mina kontaktuppgifter</button>
                </div>
            );
        }

        return (
            <EmailForm
                email={this.props.email}
                phone={this.props.phoneNumber}
                mobile={this.props.mobileNumber}
                onFormSubmit={(formData) => {
                    this.props.onInfoSave(formData);
                }}
                onFormCancel={() => {
                    this.props.onInfoCancel();
                }}
            />
        );
    }

    render() {
        return (
            <CustomerInfoSection>
                <MetaList border={false}>
                    <MetaListItem
                        title={"Namn"}
                        contents={[
                            <React.Fragment>
                                {this.props.name}
                                <InfoBox isMemberInfoPage={true} fontSize={16}>
                                    Namn, adress och personnummer hämtas från folkbokföringen och kan inte ändras på webbplatsen. Om uppgifterna är felaktiga så kontakta kundservice på 0771-21 09 09.
                                </InfoBox>
                            </React.Fragment>
                        ]}
                    />
                    <MetaListItem
                        title={"Adress"}
                        contents={[
                            this.props.adressLine1,
                            this.props.adressLine2,
                        ]}
                    />
                    <MetaListItem
                        contents={[
                            this.getContactInfo()
                        ]}
                    />
                </MetaList>
            </CustomerInfoSection>
        );
    }
};